<template>
  <v-list>
    <v-card-text v-if="profile && destinations">
      <v-subheader>
        Мои адреса и подписки
        <v-spacer></v-spacer>
        <v-menu offset-y left>
          <v-btn icon dark color="red lighten-1" small slot="activator">
            <v-icon>add</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile>
              <new-email-dialog :profile="profile" @added="addedDestination"></new-email-dialog>
            </v-list-tile>
            <v-list-tile>
              <new-phone-dialog :profile="profile" @added="addedDestination"></new-phone-dialog>
            </v-list-tile>
            <v-list-tile>
              <new-telegram-dialog :profile="profile" @added="addedDestination"></new-telegram-dialog>
            </v-list-tile>
            <v-list-tile>
              <new-viber-dialog :profile="profile" @added="addedDestination"></new-viber-dialog>
            </v-list-tile>
            <v-list-tile>
              <new-vk-dialog :profile="profile" @added="addedDestination"></new-vk-dialog>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-subheader>
      <v-list>
        <template v-for="(destination, index) in destinations">
          <v-divider v-if="index === -1" :key="destination.destinationid"></v-divider>
          <destination :destination="destination" :key="destination.destinationid"
            @change="() => updateDestination(destination)"
          ></destination>
        </template>
      </v-list>
    </v-card-text>
    <v-progress-linear v-else indeterminate></v-progress-linear>
  </v-list>
</template>

<script>
import Destination from '@/components/Destination.vue'
import NewPhoneDialog from '@/components/NewPhoneDialog.vue'
import NewEmailDialog from '@/components/NewEmailDialog.vue'
import NewTelegramDialog from '@/components/NewTelegramDialog.vue'
import NewViberDialog from '@/components/NewViberDialog.vue'
import NewVkDialog from '@/components/NewVkDialog.vue'
export default {
  name: 'settings-destinations',
  components: { Destination, NewPhoneDialog, NewEmailDialog, NewTelegramDialog, NewViberDialog, NewVkDialog },
  props: ['profile'],
  data: () => ({
    destinations: null
  }),
  methods: {
    async fetch () {
      const { destinations } = await this.$store.dispatch('sioRequest', {
        topic: 'destinations',
        pl: {}
      })
      this.destinations = destinations
    },
    async updateDestination (destination) {
      try {
        console.log(destination)
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'destinations-update',
          pl: destination
        })
        this.$store.dispatch('snack', meta.msg)
        await this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
        this.fetch()
      }
    },
    async addedDestination () {
      await this.fetch()
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>
